<template>
  <div class="home">
    <div class="top-banner" :style="homePageBanner"></div>
    <div class="tab-bar" :class="{fixed: tabFixed}" :style="homePageNavigationBackground" v-if="judgeTab">
      <div class="tabs" v-if="!searchExpanded">
        <div class="tab-item"
             @click="switchTab(hotColumn)"
             :class="{active: activeTab===hotColumn}"
             v-if="hotButtonSelect"
             :style="[
               {color: activeTab===hotColumn?filterBoxTextSelect:filterBoxText},
               {backgroundImage: 'url(\''+(activeTab===hotColumn?navigationFlowerSelect:'')+'\')'},
               {width: isFourTag?'1.58rem':'1.70rem'}
             ]"
        >
          <img class="tab-icon"
               :src="activeTab===hotColumn?hotIconSelect:hotIcon"
               alt="">
          {{ hotColumn }}
          <div class="tab-item-after"
               :style="{backgroundImage: 'url(\''+(activeTab===hotColumn?navigationSliderSelect:'')+'\')'}"></div>
        </div>
        <div class="tab-item"
             @click="switchTab(themeColumn)"
             :class="{active: activeTab===(themeColumn),
             'tab-margin': projectDetail.homePageFunction&&projectDetail.homePageFunction[2].buttonSelect}"
             v-if="themeButtonSelect"
             :style="[
               {color: activeTab===themeColumn?filterBoxTextSelect:filterBoxText},
               {backgroundImage: 'url(\''+(activeTab===themeColumn?navigationFlowerSelect:'')+'\')'},
                {width: isFourTag?'1.58rem':'1.70rem'}
               ]"
        >
          <img class="tab-icon"
               :src="activeTab===themeColumn?themeIconSelect:themeIcon"
               alt="">
          {{ getThemeName(selectedThemeId) || themeColumn }}
          <div class="tab-item-after"
               :style="{backgroundImage: 'url(\''+(activeTab===themeColumn?navigationSliderSelect:'')+'\')'}"></div>
          <img class="tab-dropdown-icon"
               :src="activeTab===themeColumn?navigationTriangleSelect:navigationTriangle"
               alt="">
        </div>
        <div class="tab-item"
             @click="switchTab(cityColumn)"
             :class="{active: activeTab===cityColumn,
             'tab-margin': projectDetail.homePageFunction&&projectDetail.homePageFunction[1].buttonSelect}"
             v-if="cityButtonSelect"
             :style="[
               {color: activeTab===cityColumn?filterBoxTextSelect:filterBoxText},
               {backgroundImage: 'url(\''+(activeTab===cityColumn?navigationFlowerSelect:'')+'\')'},
                {width: isFourTag?'1.58rem':'1.70rem'}
             ]"
        >
          <img class="tab-icon"
               :src="activeTab===cityColumn?cityIconSelect:cityIcon"
               alt="">
          {{ selectedCity || cityColumn }}
          <div class="tab-item-after"
               :style="{backgroundImage: 'url(\''+(activeTab===cityColumn?navigationSliderSelect:'')+'\')'}"></div>
          <img class="tab-dropdown-icon"
               :src="activeTab===cityColumn?navigationTriangleSelect:navigationTriangle"
               alt="">
        </div>
        <div class="tab-item"
             @click="switchTab(heroicModelColumn)"
             :class="{active: activeTab===heroicModelColumn}"
             v-if="heroicModelButtonSelect"
             :style="[
               {color: filterBoxText},
               {backgroundImage: 'url(\''+(activeTab===heroicModelColumn?navigationFlowerSelect:'')+'\')'},
                {width: isFourTag?'1.58rem':'1.70rem'}
             ]"
        >
          <img class="tab-icon"
               :src="heroicModelIcon"
               alt="">
          {{ heroicModelColumn }}
        </div>
      </div>
      <div @click="expandSearch" class="search-item"
           :class="[{expanded: searchExpanded}, {'expanded-non': judgeSearch}]" v-if="searchButtonSelect">
        <img v-if="searchExpanded && !judgeSearch" class="search-back" src="../assets/icon_back.png" alt=""
             @click.stop="collapseSearch">
        <img class="search-icon" :src="searchIcon" alt="" :style="{left:isFourTagExpanded}">
        <input ref="searchInput" class="search-input" type="text" :placeholder="searchExpanded ? searchColumn : '搜索'"
               :style="[{width:isFourTag&&!searchExpanded?'0.7rem':'100%'},
               {height:isFourTag&&!searchExpanded?' 0.64rem':'100%'}]"
               v-model="searchName">
        <div v-if="searchExpanded" class="search-btn" @click="handleSearch" :style="mainButton">搜索</div>
      </div>
    </div>
    <div class="list-container" :class="{fixed: tabFixed}" :style="homePageListBackground">
      <List v-if="pavilionList.length || loading" class="pavilion-list" :style="{minHeight: listMinHeight}"
            @load="loadMore" :finished="finished" v-model="loading" :immediate-check="false">
        <div class="pavilion-item" v-for="(p, i) in pavilionList" :key="p.id" @click="goDetail(p)">
          <img :src="homePageCardImages[i%3]" alt="">
          <div class="pavilion-cover" v-lazy:background-image="p.listUrl"></div>
        </div>
      </List>
      <div v-else class="no-content-placeholder" :style="{minHeight: listMinHeight}">
        <img class="no-content__img" :src="noDataDefaultImage" alt="">
        <div class="no-content__text">{{ emptyText }}</div>
      </div>
    </div>
    <!-- 地市弹窗 -->
    <Popup v-model="cityPopupVisible" @close="refresh" :overlay-style="overlayStyle" position="bottom">
      <div class="popup__inner city-popup" :style="projectBackground">
        <div class="popup-title" :style="{color:projectDetail.colors&&projectDetail.colors.mainText}">
          选择{{ cityColumn }}
        </div>
        <img class="popup-close-icon" src="../assets/icon_delete.png" alt="" @click="closeCityPopup">
        <div class="popup-item-grid">
          <div class="popup-item-row" v-for="(r, idx) in cityGrid" :key="'r_' + idx">
            <div class="popup-item" v-for="(c, i) in r"
                 :class="{active: selectedCity===c}"
                 :style="[{background: (selectedCity===c)?(projectDetail.colors&&projectDetail.colors.checkBoxBackgroundSelect):(projectDetail.colors&&projectDetail.colors.checkBoxBackground)},
                         {color: (selectedCity===c)?(projectDetail.colors&&projectDetail.colors.checkBoxTextSelect):(projectDetail.colors&&projectDetail.colors.checkBoxText)}]"
                 :key="i"
                 @click="selectCity(c)">{{ c }}
            </div>
          </div>
        </div>
      </div>
    </Popup>
    <Popup v-model="themePopupVisible" @close="refresh" :overlay-style="overlayStyle" position="bottom">
      <div class="popup__inner theme-popup" :style="projectBackground">
        <div class="popup-title" :style="{color:projectDetail.colors&&projectDetail.colors.mainText}">选择{{
            themeColumn
          }}
        </div>
        <img class="popup-close-icon" src="../assets/icon_delete.png" alt="" @click="closeThemePopup">
        <div class="popup-item-grid">
          <div class="popup-item-row" v-for="(r, idx) in themeGrid" :key="'r_' + idx">
            <div class="popup-item" v-for="(t, i) in r"
                 :style="[{background: (selectedThemeId===t.id)?(projectDetail.colors&&projectDetail.colors.checkBoxBackgroundSelect):(projectDetail.colors&&projectDetail.colors.checkBoxBackground)},
                         {color: (selectedThemeId===t.id)?(projectDetail.colors&&projectDetail.colors.checkBoxTextSelect):(projectDetail.colors&&projectDetail.colors.checkBoxText)}]"
                 :class="{active: selectedThemeId===t.id}"
                 :key="i"
                 @click="selectTheme(t)">{{ t.themeName }}
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import $ from 'jquery'
import { List, Popup, Toast } from 'vant'
import { getExhibitionList, getExhibitionSearch, getProjectDetail } from '@/api'
import initWxShare from '@/utils/wx'
import loadjs from 'loadjs'
import { WX_JSAPI_URL } from '@/utils/constants'
import { caiji } from '@/api/common'
import { setDocumentTitle } from '@/utils/dom'
import { isNfPlus } from '@/utils/env'
import store from '@/store'
import throttle from '../utils/throttle'

const cityList = [
  '广州',
  '深圳',
  '珠海',
  '汕头',
  '佛山',
  '韶关',
  '河源',
  '梅州',
  '惠州',
  '汕尾',
  '东莞',
  '中山',
  '江门',
  '阳江',
  '湛江',
  '茂名',
  '肇庆',
  '清远',
  '潮州',
  '揭阳',
  '云浮',
  '其他',
]

export default {
  name: 'Home',
  components: {
    List,
    Popup,
  },
  data () {
    return {
      projectDetail: {},
      tabFixed: false,
      emptyText: '正在建设更新中',
      tabs: [
        {
          title: '热门',
          icon: 'icon_hot',
          dropdown: false,
        },
        {
          title: '地市',
          icon: 'icon_location',
          dropdown: true,
        },
        {
          title: '主题',
          icon: 'icon_topic',
          dropdown: true,
        },
      ],
      activeTab: '',
      cityPopupVisible: false,
      themePopupVisible: false,
      overlayStyle: {
        background: 'rgba(0, 0, 0, .6)',
      },
      searchExpanded: false,
      cityList,
      themeList: [],
      hot: 1,
      selectedCity: '',
      selectedThemeId: '',
      searchName: '',
      refreshing: false,
      loading: false,
      finished: false,
      page: 0,
      size: 5,
      pavilionList: [],
      listMinHeight: 0,
      backgroundImage: {
        homePageTopImages: {
          homePageBanner: '',
        },
      },
    }
  },
  computed: {
    // 全部都不选，隐藏tab-bar
    judgeTab () {
      return (this.projectDetail?.homePageFunction?.[0]?.buttonSelect ||
        this.projectDetail?.homePageFunction?.[1]?.buttonSelect ||
        this.projectDetail?.homePageFunction?.[2]?.buttonSelect ||
        this.projectDetail?.homePageFunction?.[3]?.buttonSelect ||
        this.projectDetail?.homePageFunction?.[4]?.buttonSelect)
    },
    // true：热门、地市、主题、英模 全隐藏，不是全隐藏都不展开搜索框
    judgeSearch () {
      const p = this.projectDetail
      const flag = !(p.homePageFunction?.[0]?.buttonSelect || p.homePageFunction?.[1]?.buttonSelect || p.homePageFunction?.[2]?.buttonSelect || p.homePageFunction?.[4]?.buttonSelect)
      return flag
    },
    // 大于等于个4tab被选中的时候
    isFourTag () {
      let count = 0
      for (let i = 0; i < this.projectDetail.homePageFunction.length; i++) {
        if (this.projectDetail.homePageFunction[i].buttonSelect && i !== 3) {
          count++
        }
      }
      return count >= 4
    },
    /**
     * 1、三个tab,不展开：0.2rem
     * 2、四个tab,不展开：0.4rem
     * 3、展开：1.09rem
     * 4、全部tab隐藏：0.6rem
     * @returns {*|boolean}
     */
    isFourTagExpanded () {
      if (this.judgeSearch) {
        return '0.6rem'
      } else {
        if (this.searchExpanded) {
          return '1.09rem'
        } else {
          if (this.isFourTag) {
            return '0.2rem'
          } else {
            return '0.4rem'
          }
        }
      }
    },
    // 首页banner图
    homePageBanner () {
      return { backgroundImage: 'url('.concat(this.projectDetail.homePageTopImages?.homePageBanner, ')') }
    },
    // 首页导航背景图
    homePageNavigationBackground () {
      return { backgroundImage: 'url('.concat(this.projectDetail.homePageTopImages?.homePageNavigationBackground, ')') }
    },
    // 首页列表背景图
    homePageListBackground () {
      return { background: 'url('.concat(this.projectDetail.homePageTopImages?.homePageListBackground, ')', ' 0 0 / 100% 100%') }
    },
    // 主页卡片默认图
    homePageCardImages () {
      const card = this.projectDetail?.homePageCardImages
      const h = []
      h.push(card.first)
      h.push(card.second)
      h.push(card.third)
      return h
    },
    // 导航选中滑块
    navigationSliderSelect () {
      return this.projectDetail.homePageTopImages?.navigationSliderSelect
    },
    // 导航选中花纹
    navigationFlowerSelect () {
      return this.projectDetail.homePageTopImages?.navigationFlowerSelect
    },
    // 筛选框未选中颜色
    filterBoxText () {
      return this.projectDetail.colors?.filterBoxText
    },
    // 筛选框选中颜色
    filterBoxTextSelect () {
      return this.projectDetail?.colors?.filterBoxTextSelect
    },
    // 导航三角未选中
    navigationTriangle () {
      return this.projectDetail.homePageTopImages?.navigationTriangle
    },
    // 导航三角选中
    navigationTriangleSelect () {
      return this.projectDetail.homePageTopImages?.navigationTriangleSelect
    },
    // 热门筛选框
    hotButtonSelect () {
      return this.projectDetail?.homePageFunction?.[0]?.buttonSelect
    },
    hotColumn () {
      return this.projectDetail?.homePageFunction?.[0]?.column
    },
    hotIcon () {
      return this.projectDetail?.homePageFunction?.[0]?.icon
    },
    hotIconSelect () {
      return this.projectDetail?.homePageFunction?.[0]?.iconSelect
    },
    // 主题筛选框
    themeButtonSelect () {
      return this.projectDetail?.homePageFunction?.[2]?.buttonSelect
    },
    themeColumn () {
      return this.projectDetail?.homePageFunction?.[2]?.column
    },
    themeIcon () {
      return this.projectDetail?.homePageFunction?.[2]?.icon
    },
    themeIconSelect () {
      return this.projectDetail?.homePageFunction?.[2]?.iconSelect
    },

    // 地市筛选框
    cityButtonSelect () {
      return this.projectDetail?.homePageFunction?.[1]?.buttonSelect
    },
    cityColumn () {
      return this.projectDetail?.homePageFunction?.[1]?.column
    },
    cityIcon () {
      return this.projectDetail?.homePageFunction?.[1]?.icon
    },
    cityIconSelect () {
      return this.projectDetail?.homePageFunction?.[1]?.iconSelect
    },
    // 英模筛选框
    heroicModelButtonSelect () {
      return this.projectDetail?.homePageFunction?.[4]?.buttonSelect
    },
    heroicModelColumn () {
      return this.projectDetail?.homePageFunction[4]?.column
    },
    heroicModelIcon () {
      return this.projectDetail?.homePageFunction?.[4]?.icon
    },
    heroicModelIconSelect () {
      return this.projectDetail?.homePageFunction?.[4]?.iconSelect
    },
    // 搜索筛选框
    searchButtonSelect () {
      return this.projectDetail?.homePageFunction?.[3]?.buttonSelect
    },
    // 搜索文案
    searchColumn () {
      return this.projectDetail?.homePageFunction?.[3]?.column
    },
    // 搜索图标
    searchIcon () {
      return this.projectDetail?.homePageFunction?.[3]?.iconSelect
    },
    // 无数据缺省图
    noDataDefaultImage () {
      return this.projectDetail?.noDataDefaultImage || '../assets/icon_empty.png'
    },
    // 颜色

    // 活动背景主色
    projectBackground () {
      return { backgroundImage: 'linear-gradient(180deg,'.concat(this.projectDetail.colors?.projectBackgroundStart, ' 0%, ', this.projectDetail.colors?.projectBackgroundEnd, ' 100%)') }
    },
    // 主按钮⾊值
    mainButton () {
      return { backgroundImage: 'linear-gradient(180deg,'.concat(this.projectDetail.colors?.mainButtonStart, ' 0%, ', this.projectDetail.colors?.mainButtonEnd, ' 100%)') }
    },
    projectId () {
      return this.$route.query.id
    },
    city () {
      const city = this.$route.query.city
      return cityList.includes(city) ? city : ''
    },
    cityGrid () {
      return cityList.reduce((pre, cur, curIdx) => {
        const curRow = Math.floor(curIdx / 4)
        if (curIdx % 4 !== 0) {
          pre[curRow].push(cur)
        } else {
          pre[curRow] = [cur]
        }
        return pre
      }, [])
    },
    themeGrid () {
      return this.projectDetail?.themeVOList?.reduce((pre, cur, curIdx) => {
        const curRow = Math.floor(curIdx / 4)
        if (curIdx % 4 !== 0) {
          pre[curRow].push(cur)
        } else {
          pre[curRow] = [cur]
        }
        return pre
      }, []) || []
    },
    shareConfig () {
      return {
        // shareTitle: this.city ? '广东网上红色展馆' : this.projectDetail.homeShareTitle,
        // shareDesc: this.city ? `在${this.city}，云游身边的红色宝藏` : this.projectDetail.homeShareDescribe,
        shareTitle: this.city ? this.projectDetail.cityShareTitle : this.projectDetail.homeShareTitle,
        shareDesc: this.city ? (this.projectDetail.cityShareDescription.includes('XX') ? this.projectDetail.cityShareDescription.replace('XX', this.city) : this.projectDetail.cityShareDescription) : this.projectDetail.homeShareDescribe,
        shareIcon: this.projectDetail.homeShareIcon?.replace('http://', 'https://'),
        shareUrl: this.city ? `${process.env.VUE_APP_H5_URL}/#/?id=${this.projectId}&city=${encodeURIComponent(this.city)}` : `${process.env.VUE_APP_H5_URL}/#/?id=${this.projectId}`,
      }
    },
  },
  watch: {
    activeTab () {
      this.listMinHeight = Math.min(window.innerHeight - $('.top-banner').height(), window.innerHeight) + 'px'
    },
    async selectedCity (newVal, oldVal) {
      if (oldVal && !newVal) {
        await this.$router.replace({
          query: {
            ...this.$route.query,
            city: '',
          },
        })
      }
    },
    '$route.query.city' () {
      this.setShareInfo()
    },
  },
  async created () {
    // noinspection ES6MissingAwait
    caiji(this.projectId)
    this.loading = true
    if (this.projectId) {
      await this.fetchDetail()
    } else {
      this.loading = false
      return Toast.fail('不存在该项目')
    }
    // 手动设置页面标题
    if (this.projectDetail.projectName) {
      setDocumentTitle(this.projectDetail.projectName)
    }
    this.setShareInfo()
    if (this.city) {
      this.switchTab(this.projectDetail.homePageFunction[1].column)
      this.selectCity(this.city)
      await this.loadMore()
    } else {
      await this.loadMore()
    }
    this.loading = false
    if (typeof window.WeixinJSBridge === 'object' && typeof window.WeixinJSBridge?.invoke === 'function') {
      this.handleFontSize()
    } else {
      window.document.addEventListener('WeixinJSBridgeReady', this.handleFontSize, false)
    }
  },
  mounted () {
    $(window).on('scroll', this.handleWindowScroll)
    this.listMinHeight = Math.min(window.innerHeight - $('.top-banner').height() + window.scrollY, window.innerHeight) + 'px'
  },
  activated () {
    if (!this.loading) {
      this.setShareInfo()
    }
  },
  beforeDestroy () {
    $(window).off('scroll', this.handleWindowScroll)
  },
  methods: {
    handleWindowScroll (event) {
      const bannerHeight = $('.top-banner').height()
      if (window.scrollY > bannerHeight && !this.tabFixed) {
        this.tabFixed = true
      } else if (window.scrollY < bannerHeight && this.tabFixed) {
        this.tabFixed = false
      }
    },
    async setShareInfo () {
      console.log('正在设置分享信息', this.shareConfig)
      if (!(this.shareConfig.shareTitle && this.shareConfig.shareDesc && this.shareConfig.shareIcon && this.shareConfig.shareUrl)) {
        console.log('分享信息不完整，已取消分享', this.shareConfig)
        return
      }
      if (isNfPlus()) {
        try {
          // 端内分享
          window.nfplusJsbridge.setShareInfo(this.shareConfig)
        } catch (e) {
          console.log(e)
        }
      }
      if (!this.$root.wxLoaded) {
        await loadjs([WX_JSAPI_URL], { returnPromise: true }).then(() => {
          this.$root.wxLoaded = true
          return initWxShare({
            title: this.shareConfig.shareTitle,
            desc: this.shareConfig.shareDesc,
            imgUrl: this.shareConfig.shareIcon,
            link: this.shareConfig.shareUrl,
          }).catch(() => {
          })
        }).catch(() => {
        })
      } else {
        await initWxShare({
          title: this.shareConfig.shareTitle,
          desc: this.shareConfig.shareDesc,
          imgUrl: this.shareConfig.shareIcon,
          link: this.shareConfig.shareUrl,
        }).catch(() => {
        })
      }
    },
    switchTab (tab) {
      if (tab === this.hotColumn && tab === this.activeTab) {
        return
      }
      if (tab === this.cityColumn) {
        // 地市
        this.activeTab = this.cityColumn
        this.hot = 0
        this.cityPopupVisible = true
      } else if (tab === this.themeColumn) {
        // 主题
        this.activeTab = this.themeColumn
        this.hot = 0
        this.themePopupVisible = true
        this.setShareInfo()
      } else if (tab === this.heroicModelColumn) {
        // 英模
        // 外链内链
        if (this.projectDetail.heroicModelArticleLink) {
          const url = isNfPlus() ? (this.projectDetail.heroicModelArticleLink?.jumpUrl || this.projectDetail.heroicModelArticleLink?.shareUrl) : this.projectDetail.heroicModelArticleLink?.shareUrl
          window.open(url)
        }
      } else {
        // 热门
        this.activeTab = this.hotColumn
        this.hot = 1
        this.selectedThemeId = ''
        this.selectedCity = ''
        this.refresh()
      }
    },
    expandSearch () {
      if (!this.searchExpanded) {
        this.searchExpanded = true
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus()
          }
        })
      }
    },
    collapseSearch () {
      if (this.searchExpanded) {
        this.searchExpanded = false
      }
      this.searchName = ''
      this.refresh()
    },
    handleSearch: throttle(function () {
      this.refresh()
      this.emptyText = this.projectDetail.noSearchResultText || '暂无匹配数据'
    }),
    fetchDetail () {
      return getProjectDetail(this.projectId).then(res => {
        this.projectDetail = res.data
        if (this.judgeSearch) {
          this.searchExpanded = true
        }
        // 设置热门为默认光亮
        this.activeTab = this.projectDetail?.homePageFunction[0]?.column
      })
    },
    fetchList () {
      const params = {
        pageNum: this.page,
        pageSize: this.size,
        projectId: this.projectId,
        themeId: this.selectedThemeId,
        city: this.selectedCity,
        hot: this.hot,
      }
      if (this.judgeSearch) {
        // 如果热门、地市、主题 都隐藏的话，那么非热门和热门都查出来
        params.hot = 0
      }
      return getExhibitionList(params).then(res => {
        const list = res.data.content
        this.page++
        if (!list.length) {
          this.finished = true
        }
        return list
      })
    },
    fetchSearch () {
      const params = {
        searchName: this.searchName,
        projectId: this.projectId,
        pageNum: this.page,
        pageSize: this.size,
      }
      return getExhibitionSearch(params).then(res => {
        const list = res.data.content
        this.page++
        if (!list.length) {
          this.finished = true
        }
        return list
      })
    },
    async refresh () {
      this.page = 0
      this.finished = false
      this.emptyText = this.projectDetail.categoryNoDataText || '正在建设更新中'
      await this.loadMore()
    },
    async loadMore () {
      this.loading = true
      const requester = this.searchExpanded ? this.fetchSearch : this.fetchList
      await requester().then(list => {
        this.pavilionList = this.page === 1 ? list : this.pavilionList.concat(list)
      })
      this.loading = false
    },
    closeCityPopup () {
      this.cityPopupVisible = false
    },
    closeThemePopup () {
      this.themePopupVisible = false
    },
    selectCity (city) {
      if (this.selectedCity === city) {
        this.selectedCity = ''
      } else {
        this.selectedCity = city
      }
      if (this.selectedCity !== this.$route.query.city) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            city: this.selectedCity,
          },
        })
      }
      this.selectedThemeId = ''
      this.cityPopupVisible = false
    },
    selectTheme (theme) {
      if (this.selectedThemeId === theme.id) {
        this.selectedThemeId = ''
      } else {
        this.selectedThemeId = theme.id
      }
      this.selectedCity = ''
      this.themePopupVisible = false
    },
    getThemeName (id) {
      return this.projectDetail.themeVOList?.find(t => t.id === id)?.themeName
    },
    goDetail (p) {
      // 端内并且是打卡广东红打开，使用新webview，防止iframe的load事件不响应hash的变化
      if (isNfPlus() && window.location.href.indexOf('openAt=dkgdh') && window.nfplusJsbridge && window.nfplusJsbridge.openNewWebview) {
        const url = `${window.location.origin + window.location.pathname}#/Detail?id=${p.id}&projectId=${this.projectDetail.id}`
        window.nfplusJsbridge.openNewWebview({
          articleType: 4,
          relUrl: url,
          contentUrl: url,
        })
      } else {
        sessionStorage.setItem('red_pavilion_from_home', '1')
        this.$router.push({
          name: 'Detail',
          query: {
            id: p.id,
            projectId: this.projectDetail.id,
          },
        })
      }
    },
    handleFontSize () {
      window.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
      window.WeixinJSBridge.on('menu:setfont', function () {
        window.WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.home {
  width: 100vw;

  ::v-deep {
    .van-popup {
      background: transparent;
    }
  }
}

.top-banner {
  width: 100%;
  min-height: 3.5rem;
  background: ~'url("../assets/banner.png") 0 0 / 100% 100% no-repeat';
}

.tab-bar {
  width: 100vw;
  height: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ~'url("../assets/tab_bg.png") 0 0 / 100% 100%';

  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .tabs {
    display: flex;
    height: 100%;
  }

  .tab-margin {
    margin-left: 0.11rem;
  }

  .tab-item {
    position: relative;
    flex-shrink: 0;
    height: 100%;
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    color: #FFA944;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1.70rem;
    white-space: nowrap;

    &:first-child {
      width: 1.67rem;
    }

    .tab-icon {
      flex-shrink: 0;
      margin-right: 0.08rem;
      height: 0.3rem;
    }

    .tab-dropdown-icon {
      width: 0.18rem;
      margin-left: 0.08rem;
    }

    &.active {
      font-family: PingFang-SC-Bold;
      color: #FFFFFF;
      font-weight: bold;
      // background: ~'url("") center center / 100% 100% no-repeat';

      .tab-item-after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 0.3rem;
        height: 0.1rem;
        background: ~'url("../assets/icon_current.png") 0 0 / 100% 100% no-repeat';
      }
    }
  }
}

.search-item {
  width: 1.84rem;
  height: 0.64rem;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 0.3rem;

  &.expanded {
    width: 100%;
    padding: 0 0.3rem;
    margin-right: 0;

    .search-icon {
      left: 1.09rem;
    }

    .search-input {
      text-indent: 0.73rem;
      width: 4.68rem;
    }
  }

  &.expanded-non {
    .search-icon {
      left: 0.6rem
    }
  }

  .search-back {
    height: 0.34rem;
    margin-right: 0.2rem;
    flex-shrink: 0;
  }

  .search-icon {
    position: absolute;
    left: 0.4rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.32rem;
    height: 0.32rem;
  }

  .search-input {
    display: block;
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
    border-radius: 0.32rem;
    background-color: rgba(255, 255, 255, 0.15);
    text-indent: 0.88rem;
    padding: 0;
    caret-color: rgba(255, 255, 255, 0.5);
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    color: #FFFFFF;

    &::placeholder {
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      line-height: normal;
      color: rgba(255, 255, 255, 0.5);
    }
  }

  .search-btn {
    flex-shrink: 0;
    margin-left: 0.14rem;
    width: 1.54rem;
    height: 0.64rem;
    line-height: 0.64rem;
    text-align: center;
    border-radius: 0.32rem;
    background-image: linear-gradient(180deg, #FF9630 0%, #FF710B 100%);
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    color: #FFFFFF;
  }
}

.list-container {
  background: ~'url("../assets/bg.png") 0 0 / 100% 100%';

  padding-bottom: 0.4rem;
  padding-bottom: calc(0.4rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(0.4rem + env(safe-area-inset-bottom));

  &.fixed {
    padding-top: 0.9rem;
  }

  ::v-deep {
    .van-loading, .van-loading__text, .van-list__finished-text, .van-pull-refresh__text, .van-list__error-text {
      color: rgba(255, 255, 255, 0.6);
    }
  }
}

.pavilion-list {
  padding: 0.16rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pavilion-item {
  width: 6.9rem;
  height: 2.63rem;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  .pavilion-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: 0 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  &:not(:first-child) {
    margin-top: 0.12rem;
  }
}

.no-content-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .no-content__img {
    width: 1.5rem;
    height: 1rem;
  }

  .no-content__text {
    margin-top: 0.2rem;
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: rgba(255, 255, 255, 0.46);
  }
}

.city-popup {
  height: 6.86rem;
  height: calc(6.86rem + constant(safe-area-inset-bottom));
  height: calc(6.86rem + env(safe-area-inset-bottom));
}

.theme-popup {
  min-height: 3.86rem;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.popup__inner {
  position: relative;
  overflow: auto;
  width: 100%;
  background-image: linear-gradient(180deg, #FF5837 0%, #B8301A 100%);
  border-radius: 0.4rem 0.4rem 0 0;
}

.popup-title {
  margin: 0.4rem 0;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 0.3rem;
  line-height: 0.42rem;
  color: #FFDCA3;
}

.popup-close-icon {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;
  width: 0.3rem;
  height: 0.3rem;
}

.popup-item-grid {
  width: 100%;
  padding-bottom: 0.3rem;
  display: flex;
  flex-direction: column;

  .popup-item-row {
    width: 100%;
    padding: 0 0.3rem;
    display: flex;

    &:not(:first-child) {
      margin-top: 0.2rem;

    }
  }
}

.popup-item {
  width: 1.62rem;
  height: 0.72rem;
  line-height: 0.72rem;
  text-align: center;
  background: #FDD698;
  border-radius: 0.08rem;
  font-family: PingFangSC-Regular;
  font-size: 0.3rem;
  color: #C14545;
  transition: all 0.3s;

  &:not(:first-child) {
    margin-left: 0.14rem;
  }

  &.active {
    background: #FFFCEF;
    font-family: PingFang-SC-Bold;
    color: #CA1B22;
    font-weight: bold;
  }
}

.pavilion-cover {
}
</style>
